import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHSymbol} from "../symbols/HTHSymbol";
import {HTHEnhancerSymbol} from "../symbols/HTHEnhancerSymbol";
import {HTHSafeSymbol} from "../symbols/HTHSafeSymbol";
import {HTHRemovalSymbol} from "../symbols/HTHRemovalSymbol";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHGameConfig} from "../HTHGameConfig";
import {HTHSound} from "../sound/HTHSound";

export class HTHRemovalSymbolPresentation implements SimplePresentation {

    constructor() {
    }

    shouldRun(): boolean {
        return HTH.model.isRemovalSymbolPresent && !HTH.model.isGodModeMaxWin && !HTH.model.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                HTH.screenInteractive.setInteractiveState(false);
                controller.setSkipCallback();
                controller.finish()
            }
        });
        let soundPlaySpeed: number = 1;

        if (HTH.model.gameData?.betWayWins.length === 0) {
            HTH.screenInteractive.setInteractiveState(true);
            if (HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
                // console.log("already at 1st skip removalpresentation");
                soundPlaySpeed = 2;
                tl.timeScale(2);
            } else if (HTHGameConfig.isSkipped[1]) {
                // console.log("already at 2nd skip removalpresentation");
                soundPlaySpeed = 4;
                tl.timeScale(4);
                HTH.screenInteractive.setInteractiveState(false);
            }
        }

        HTH.screenInteractive.clickArea.on('pointerdown', () => {
            if (!HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
                // console.log("1st skip removalpresentation");
                HTHGameConfig.isSkipped[0] = true;
                soundPlaySpeed = 2;
                tl.timeScale(2);
                this.checkSoundSpeed(soundPlaySpeed);
            } else if (HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
                // console.log("2nd skip removalpresentation");
                HTHGameConfig.isSkipped[1] = true;
                soundPlaySpeed = 4;
                tl.timeScale(4);
                this.checkSoundSpeed(soundPlaySpeed);
                HTH.screenInteractive.setInteractiveState(false);
            }
        });

        if (HTH.model.gameData?.betWayWins.length > 0) {
            controller.setSkipCallback(() => { //keeping in if condition because it was getting click before interactive screen
                tl.timeScale(2);
                this.checkSoundSpeed(2);
            });
        }


        // HTH.model.gameData.removalSymbolTargets.forEach((item: number[][], index: number) => {
        const removalSym: HTHSymbol = HTH.reelArea.getSymbol([HTH.model.removalSymbolPositions[0][0], HTH.model.removalSymbolPositions[0][1]]);

        if (removalSym.symName === "EB" || removalSym.symName === "SA") {
            tl.add((<HTHRemovalSymbol>((<HTHEnhancerSymbol | HTHSafeSymbol>removalSym).revealedSymbol!)).playSpineAnim("open_mouth_transition"));
        } else {
            tl.add((<HTHRemovalSymbol>removalSym).playSpineAnim("open_mouth_transition"));
        }
        if (removalSym.symName === "SA") {
            tl.add(() => {
                HTH.symbolOverlay.addChildAt(removalSym, 0);
                removalSym.position.x = removalSym.reelId * HTHGameConfig.symbolWidth
            }, "<");
        }
        tl.add(() => {
            HTHSound.playTrack(HTHSound.REMOVAL_COLLECT)?.setRate(soundPlaySpeed);
        }, "<");

        HTH.model.gameData.removalSymbolTargets.forEach((symPos: { x: number, y: number }, index: number) => {
            const targetTl: gsap.core.Timeline = gsap.timeline();
            const sym: HTHSymbol = HTH.reelArea.getSymbol([symPos.x, symPos.y]);
            let countUpSoundOnEB: number = 0;
            let countUpSoundOnSA: number = 0;
            if (sym.symName !== "SA") {
                sym.movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.maskedEffectsLayer);
            }
            targetTl.add(sym.removalExplode());
            targetTl.add(HTH.symbolOverlay.playRemovalTrailAnim(new PIXI.Point(HTH.model.removalSymbolPositions[0][0] * HTHGameConfig.symbolWidth, HTH.model.removalSymbolPositions[0][1] * HTHGameConfig.symbolHeight), new PIXI.Point(symPos.x * HTHGameConfig.symbolWidth, symPos.y * HTHGameConfig.symbolHeight)), "<0.1");
            if (index === 0) {
                targetTl.add(() => {
                    HTHSound.playTrack(HTHSound.REMOVAL_COLLECT_SWEEP)?.setRate(soundPlaySpeed);
                }, "<");
                targetTl.add(() => {
                    HTHSound.playTrack(HTHSound.REMOVAL_TARGET_SYMBOLS)?.setRate(soundPlaySpeed);
                }, 0);
            }
            if (sym.symName === "EB") {
                countUpSoundOnEB++;
                targetTl.add(() => {
                    if (HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE") {
                        (<HTHEnhancerSymbol>sym).symbolAnimChange("shutter_down");
                    }
                    else{
                        (<HTHEnhancerSymbol>sym).symbolAnimChange("shutter_down_blank");
                    }
                });
                if (countUpSoundOnEB === 1) {
                    targetTl.add(() => {
                        HTHSound.playTrack(HTHSound.ENHANCER_CELL_DOOR_CLOSE)?.setRate(soundPlaySpeed);
                    }, "<")
                }

            } else if (sym.symName === "SA") {
                countUpSoundOnSA++;
                targetTl.add(() => {
                    (<HTHSafeSymbol>sym).symbolAnimChange("close_emptyBox")
                });
                if (countUpSoundOnSA === 1) {
                    targetTl.add(() => {
                        HTHSound.playTrack(HTHSound.SAFE_CLOSE)?.setRate(soundPlaySpeed);
                    }, "<")
                }
            }

            if (removalSym.symName !== "EB" && removalSym.symName !== "SA") {
                targetTl.add((<HTHRemovalSymbol>removalSym).showWaysIncrease(sym.symSize === 0 ? 1 : sym.symSize));
            } else {
                targetTl.add((<HTHEnhancerSymbol>removalSym).showWaysIncrease(sym.symSize === 0 ? 1 : sym.symSize));
            }
            tl.add(targetTl, 0);
        });
        tl.addLabel("removalCompleted");
        if (HTH.model.removalSymbolPositions.length > 0) {
            HTH.model.removalSymbolPositions.forEach((symInfo: number[], index: number) => {
                const rwTl: gsap.core.Timeline = gsap.timeline();
                const remSymChangeTs: TimelineSprite = new TimelineSprite((HTH.assetLoader.getTextures("removalSymConvertEffect")));
                const sym: HTHSymbol = HTH.reelArea.getSymbol([symInfo[0], symInfo[1]]);

                remSymChangeTs.blendMode = PIXI.BLEND_MODES.ADD;
                remSymChangeTs.anchor.set(0.5, 0.5);

                HTHHelper.copyLocalPosition(remSymChangeTs, sym);

                rwTl.add(() => {
                    HTH.symbolOverlay.addChild(remSymChangeTs);
                }, "<");
                const miniTl: gsap.core.Timeline = gsap.timeline();
                miniTl.add(<gsap.core.Timeline><unknown>remSymChangeTs.getAnimationAutoShowHide());
                miniTl.add(() => {
                    HTHSound.playTrack(HTHSound.REMOVAL_REVEAL)?.setRate(soundPlaySpeed);
                }, "<");

                rwTl.add(miniTl, "<");


                if (sym.symName === "RW") {
                    // rwTl.add(HTH.reelArea.allReels[sym.reelId].reelView.switchSymbol(sym, HTH.model.gameData.reelsBeforeCollapse[sym.reelId][sym.id]), "<0.3");
                    rwTl.add(HTH.reelArea.allReels[sym.reelId].reelView.switchSymbol(sym, HTH.model.gameData.removalSymbol), `<+=${miniTl.duration() / 2}`);
                } else if (sym.symName === "EB") {
                    rwTl.add(() => {
                        // (<HTHEnhancerSymbol>sym).revealSymbol(HTH.model.gameData.reelsBeforeCollapse[sym.reelId][sym.id], (<HTHEnhancerSymbol>sym).revealedSymSize);
                        (<HTHEnhancerSymbol>sym).revealSymbol(HTH.model.gameData.removalSymbol, (<HTHEnhancerSymbol>sym).revealedSymSize === 0 ? 1 : (<HTHEnhancerSymbol>sym).revealedSymSize);
                        HTH.reelArea.ebSpinArea.changeSymbol(sym.reelId, HTH.model.gameData.removalSymbol, HTH.model.gameData.removalSymbolTargets.length > 0 ? HTH.model.gameData.removalSymbolTargets.length : 1);
                    }, `<+=${miniTl.duration() / 2}`);
                } else if (sym.symName === "SA") {
                    rwTl.add(() => {
                        // (<HTHSafeSymbol>sym).revealSymbol(HTH.model.gameData.reelsBeforeCollapse[sym.reelId][sym.id], 1);
                        (<HTHSafeSymbol>sym).revealSymbol(HTH.model.gameData.removalSymbol, 1);
                    }, `<+=${miniTl.duration() / 2}`);
                }
                rwTl.add(() => {
                    HTH.symbolOverlay.removeChild(remSymChangeTs);
                });
                tl.add(rwTl, "removalCompleted");
            });
        }
        if (removalSym.symName === "SA") {
            tl.add(() => {
                (<HTHSafeSymbol>removalSym).movetoParticularMaskedLayer(HTH.reelArea.allReels[removalSym.reelId].reelView.reelLayers.safeLayer);
                removalSym.position.x = 0;
            })
        }
        tl.to(this, {duration: 0.01});
    }


    private checkSoundSpeed(chosenSpeed: number): void {
        if (HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.REMOVAL_REVEAL)?.isPlaying) {
            HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.REMOVAL_REVEAL)?.setRate(chosenSpeed);
        }
        if (HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.REMOVAL_COLLECT)?.isPlaying) {
            HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.REMOVAL_COLLECT)?.setRate(chosenSpeed);
        }
        if (HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.REMOVAL_COLLECT_SWEEP)?.isPlaying) {
            HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.REMOVAL_COLLECT_SWEEP)?.setRate(chosenSpeed);
        }
        if (HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.REMOVAL_TARGET_SYMBOLS)?.isPlaying) {
            HTHSound.soundPlayer.fetchSoundPlayer(HTHSound.REMOVAL_TARGET_SYMBOLS)?.setRate(chosenSpeed);
        }
    }
}
